<template>
    <div v-if="plan.period === 1" class="flex flex-col gap-4">
        <div class="text-[18px] font-semibold">
            Test Mode: Daily Subscription
        </div>
        <div class="">
            Daily subscriptions are intended for development testing only.
        </div>
    </div>
    <div v-if="plan.period === 2" class="flex flex-col gap-4">
        <div class="text-[18px] font-semibold">Monthly Subscription</div>
        <div class="">Monthly recurring membership (cancel anytime)</div>
        <div
            class="mt-4 rounded border border-l-4 border-gray-200 border-l-secondary-500 bg-gray-200 p-8"
        >
            <div class="mb-4 font-semibold">Future Billing</div>
            You will be charged
            <span class="font-semibold">${{ plan.price_usd }}</span> USD today,
            and again on the
            <span class="font-semibold"
            >{{ dayjs().format("Do") }} of each month </span
            >. You can cancel anytime to avoid renewal for the following month.
        </div>
    </div>
    <div v-if="plan.period === 3" class="flex flex-col gap-4">
        <div class="text-[18px] font-semibold">Annual Subscription</div>
        <div class="">All-inclusive membership for one year</div>
    </div>

    <div class="my-8">
        <div
            class="border-b border-gray-400"
            v-if="!promoCodeDetails || !promoCodeDetails.valid"
        >
            <form @submit.prevent="applyPromoCode">
                <div class="flex items-center justify-between">
                    <div class="flex-grow border-b">
                        <form-input
                            css-classes="!pl-0 outline-none border-none bg-transparent placeholder:text-gray-500 w-auto"
                            v-model="form.promoCode"
                            name="promo_code"
                            placeholder="+ Apply Promo Code"
                            :hide-errors="true"
                        />
                    </div>
                    <div
                        @click="applyPromoCode"
                        :class="
                            'hover:cursor-pointer hover:text-primary-500' +
                            ' ' +
                            (form.isDirty ? 'text-gray-700' : 'text-gray-500 ')
                        "
                    >
                        Apply
                    </div>
                </div>
            </form>
        </div>

        <div class="" v-if="promoCodeDetails">
            <div
                class="flex flex-col gap-1 text-green-300"
                v-if="promoCodeDetails.valid"
            >
                <div class="flex justify-between">
                    <div class="">{{ promoCodeDetails.code }}</div>
                    <div class="flex items-center gap-2">
                        <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <circle cx="10" cy="10" r="10" fill="#0B8753"/>
                            <path
                                d="M5.45459 10.343C7.16999 11.5282 9.66512 13.2763 9.66512 14.343C10.4448 11.6763 12.4721 6.16521 14.3435 5.4541"
                                stroke="white"
                                stroke-width="1.66667"
                            />
                        </svg>
                        <div class="">Applied</div>
                    </div>
                </div>
                <div class="my-1 border-b border-gray-325"></div>
            </div>

            <div class="" v-else>
                <div class="mb-2 border-b border-red-300"></div>
                <div class="text-[12px] font-medium text-red-300">
                    You’ve entered an invalid promo code. Please try again.
                </div>
            </div>
        </div>
    </div>

    <div class="flex flex-col gap-4">
        <div class="flex justify-between">
            <div class="">Subtotal</div>
            <div class="">${{ subtotal }}</div>
        </div>
        <div class="flex justify-between">
            <div class="">Taxes</div>
            <div class="">$0.00</div>
        </div>

        <div
            class="flex justify-between"
            v-if="promoCodeDetails && promoCodeDetails.valid"
        >
            <div class="">
                <div v-if="promoCodeDetails.amount_off">
                    Discount (${{ promoCodeDetails.amount_off / 100 }})
                </div>
                <div v-if="promoCodeDetails.percent_off">
                    Discount ({{ promoCodeDetails.percent_off }}%)
                </div>
                <div class="text-[12px]">{{ promoCodeDetails.name }}</div>
            </div>
            <div class="">({{ promoCodeDetails.discount_total }})</div>
        </div>

        <div class="flex justify-between font-semibold">
            <div class="">Total</div>
            <div class="">
                USD
                <span
                    v-if="
                        promoCodeDetails &&
                        promoCodeDetails.valid &&
                        promoCodeDetails.discount_total
                    "
                >{{ promoCodeDetails.total_with_discount }}</span
                >
                <span v-else>${{ total }}</span>
            </div>
        </div>
    </div>
</template>
<script>
import FormInput from "@/Components/FormInput";

export default {
    name: "StudentCheckoutCart",
    components: {
        FormInput,
    },
    emits: ["promo-applied"],
    props: {
        plan: {
            type: Object,
            default: {},
        },
        subtotal: {
            type: [Number, String],
            default: 0,
        },
        total: {
            type: [Number, String],
            default: 0,
        },
        promoCode: {
            type: String,
            default: "",
        },
        orderId: {
            type: Number,
            default: null,
        },
    },
    data() {
        return {
            form: this.$inertia.form({
                promoCode: this.promoCode,
            }),
            promoCodeDetails: null,
        };
    },
    methods: {
        applyPromoCode() {
            let vm = this;
            axios
                .post(route("validate-promo-code"), {
                    promo_code: this.form.promoCode,
                    subtotal: this.plan.price_usd,
                })
                .then(function (response) {
                    vm.promoCodeDetails = response.data;

                    if (vm.promoCodeDetails.valid === false) {
                        vm.$page.props.errors["promo_code"] =
                            '"' +
                            vm.form.promoCode +
                            '" is not a valid promo code';
                    } else {
                        vm.$emit("promo-applied", vm.promoCodeDetails.code);
                        vm.$page.props.total_usd =
                            vm.promoCodeDetails.total_with_discount;

                        if (vm.orderId) {
                            axios.post(
                                route("apply-promo-code", {
                                    order: vm.orderId,
                                }),
                                {
                                    promo_code: vm.promoCodeDetails.code,
                                }
                            );
                        }
                    }
                });
        },
    },
    mounted() {
        if (this.promoCode) {
            this.applyPromoCode();
        }
    },
};
</script>
